<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_GUEST_SEARCH' | translate}}</h6>
        <button type="button" class="close" aria-label="Close" (click)="onSelect(null);d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid manualAssign guestSearchBody">
        <form name="frm" (submit)="onSubmit()">
            <div class="form-group">
                <div class="row">
                    <div class="col-auto"><label class="col-form-label" translate>LBL.SEARCH_BY_NAME</label></div>
                    <div class="col">
                        <div><input type="text" class="form-control " name="Keyword" [(ngModel)]="RequestModel.Keyword" (keyup)="IsLoaded && searchGuestOnKey()" /></div>
                        <div *ngIf="IsLoaded && RequestModel.Keyword != null && RequestModel.Keyword.trim().length > 0 && guestlst.length > 0"><button class="btn btn-link pl-0" (click)="onSubmit()" translate>BTN.BTN_LOOKUP_IN_PREVIOUS_RESERVATION</button></div>
                        <div *ngIf="!IsLoaded && guestlst.length > 0"><button class="btn btn-link pl-0" (click)="loadPreviousData()" translate>BTN.BTN_LOOKUP_IN_CURRENT_RESERVATION</button></div>
                    </div>
                    <div class="col-auto"><button type="submit" [disabled]="!RequestModel.Keyword" [hidden]="IsLoaded && guestlst.length > 0" class="btn btn-primary" name="submit" translate>BTN.BTN_SEARCH</button></div>
                </div>
                
                <div class="">

                </div>
                <div class="selectBox">

                </div>
            </div>
        </form>

        <div *ngIf="Model && ((IsLoaded && guestlst.length == 0) || Model.TotalRecords == 0)" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>

        <div class="row align-items-center" *ngIf="Model && ((IsLoaded && Model.length > 0) || Model.TotalRecords > 0)">
            <div class="col-auto mr-4" >
                <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="IsLoaded ? guestlst.length : Model.TotalRecords" [pageSize]="RequestModel.PageSize" [(page)]="RequestModel.PageNumber" [boundaryLinks]="true" (pageChange)="onPageChange()"></ngb-pagination>
            </div>
            <div class="col-auto" *ngIf="Model"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{IsLoaded ? guestlst.length : Model.TotalRecords}}</B></div>
        </div>

        <sk-wave [isRunning]="IsSubmitting"></sk-wave>

        <div class="grdTable" *ngIf="IsSubmitting == false && Model && ((Model.Result != null && Model.Result.length > 0) || (IsLoaded && Model.length > 0))">
            <div class="grdBodyScroll-Virtual overflow-auto" *ngIf="IsLoaded">
                <div *ngFor="let row of Model" class="d-flex grdRow justify-content-between px-2">
                    <div class="grdCol">{{row.FullName}}</div>
                    <div class="grdCol"><label *ngIf="row.GuestId == SelectedId" translate>LBL.SELECTED</label> <button *ngIf="row.GuestId != SelectedId" class="btn btn-link p-0" (click)="onSelect(row);" translate>{{ disableCloseOnSelect ? "LBL.LBL_VIEW_DETAILS" : "BTN.BTN_SELECT" }}</button></div>
                </div>
            </div>
            <div class="grdBodyScroll-Virtual overflow-auto" *ngIf="!IsLoaded">
                <div *ngFor="let row of Model.Result" class="d-flex grdRow justify-content-between px-2">
                    <div class="grdCol">{{row.FullName}}</div>
                    <div class="grdCol"><label *ngIf="row.GuestId == SelectedId" translate>LBL.SELECTED</label> <button *ngIf="row.GuestId != SelectedId" class="btn btn-link p-0" (click)="onSelect(row);" translate>{{ disableCloseOnSelect ? "LBL.LBL_VIEW_DETAILS" : "BTN.BTN_SELECT" }}</button></div>
                </div>
            </div>
            <!--<div class="grdBodyScroll-Virtual" #scrollingBlock>
        <virtual-scroller #scroll [items]="IsLoaded ? Model : Model.Result" style="height:100%" [parentScroll]="scrollingBlock.nativeElement">
            <div *ngFor="let row of scroll.viewPortItems" class="d-flex grdRow justify-content-between px-2">
                <div class="grdCol">{{row.FullName}}</div>
                <div class="grdCol"><label *ngIf="row.GuestId == SelectedId" translate>LBL.SELECTED</label> <button *ngIf="row.GuestId != SelectedId" class="btn btn-link p-0" (click)="onSelect(row);" translate>BTN.BTN_SELECT</button></div>
            </div>
        </virtual-scroller>
    </div>-->
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-secondary" type="button" (click)="onSelect(null);c('')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>

<StaffJobList #staffJobList></StaffJobList>
